import React from 'react';

export type DatePickerContextType = {
  currentDate: Date;
  setCurrentDate: (_: Date) => void;
};

export const DatePickerContext = React.createContext<DatePickerContextType>(
  {} as DatePickerContextType,
);

export const DatePickerConsumer = DatePickerContext.Consumer;
export const DatePickerProvider = DatePickerContext.Provider;

export const useDatePicker = () => React.useContext(DatePickerContext);
